var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluentAdd16Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.125C12.75 3.82663 12.6315 3.54048 12.4205 3.3295C12.2095 3.11853 11.9234 3 11.625 3C11.3266 3 11.0405 3.11853 10.8295 3.3295C10.6185 3.54048 10.5 3.82663 10.5 4.125V10.5H4.125C3.82663 10.5 3.54048 10.6185 3.3295 10.8295C3.11853 11.0405 3 11.3266 3 11.625C3 11.9234 3.11853 12.2095 3.3295 12.4205C3.54048 12.6315 3.82663 12.75 4.125 12.75H10.5V19.125C10.5 19.4234 10.6185 19.7095 10.8295 19.9205C11.0405 20.1315 11.3266 20.25 11.625 20.25C11.9234 20.25 12.2095 20.1315 12.4205 19.9205C12.6315 19.7095 12.75 19.4234 12.75 19.125V12.75H19.125C19.4234 12.75 19.7095 12.6315 19.9205 12.4205C20.1315 12.2095 20.25 11.9234 20.25 11.625C20.25 11.3266 20.1315 11.0405 19.9205 10.8295C19.7095 10.6185 19.4234 10.5 19.125 10.5H12.75V4.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentAdd16Filled);
export default __webpack_public_path__ + "static/media/fluent_add-16-filled.5d9129c835bd53701aad2083c54936b7.svg";
export { ForwardRef as ReactComponent };